import { create } from 'zustand';
import { jwtDecode } from 'jwt-decode';
import { BACKEND_ENDPOINT, log } from 'utils/Common';

export interface PlanState {
    plan: string | null;
    collectionsLimit: number | null;
    userLogin: (accessToken: string) => Promise<void>;
}

const usePlan = create<PlanState>((set) => ({
    plan: null,
    collectionsLimit: null,
    userLogin: async (accessToken: string) => {
        const decoded: any = jwtDecode(accessToken);
        const res = await fetch(BACKEND_ENDPOINT + 'user/login', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId: decoded.sub })
        });
        const text = await res.text();
        if (!res.ok || !text) {
            log(`fetchPlan failed: ${res.status}`);
            return;
        }
        const data = JSON.parse(text);
        log(`fetchPlan: plan=${data.plan}, collectionsLimit=${data.collectionsLimit}`);
        set({ plan: data.plan, collectionsLimit: data.collectionsLimit });
    }
}));

export default usePlan;
